import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "id" : uuidv4(),
    "data": {
        isFetchingCallLog: false,
        callLogUpdated: false,
        callLogs: {},
        callAudioMute:false}
}

const muteUpdate = (payload,state) => {
    return { ...state,callAudioMute:payload }
}
const fetchingCallLogs = (payload,state) => {
    return { ...state,isFetchingCallLog:payload }
}

const insertCallLogs = (state, payload) => {
    const newState = { ...state };
    newState.callLogUpdated = !newState.callLogUpdated;
    let newCallLogs = { ...newState.callLogs };
    newCallLogs[payload.roomId] = payload;
    newState.callLogs = newCallLogs;
    return newState;
}

const calllogsDataSlice = createSlice({
    name:'calllogsDataSlice',
    initialState,
    reducers:{
        insertCallLog: (_state,payload)=>{
            return {
                "id" : uuidv4(),
                "data": insertCallLogs(StateToObj(_state).data,payload.payload)
            }
        },
        fetchingCallLog:(_state,payload)=>{
            return {
             "id" : uuidv4(),
             "data": fetchingCallLogs(payload.payload,StateToObj(_state).data)
            }
     },
        addIsMuteListner: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": muteUpdate(payload.payload,StateToObj(_state).data)
               }
        },
        resetAudioMute: (_state,payload)=>{
            return initialState
     }

    }
});

export default calllogsDataSlice.reducer
export const insertCallLog = calllogsDataSlice.actions.insertCallLog
export const fetchingCallLog = calllogsDataSlice.actions.fetchingCallLog
export const addIsMuteListner = calllogsDataSlice.actions.addIsMuteListner
export const resetAudioMute = calllogsDataSlice.actions.resetAudioMute